const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLike(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 15,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h15v15H0z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.239 3.738a4.361 4.361 0 0 0-5.743.82 4.353 4.353 0 0 0-5.743-.82A4.074 4.074 0 0 0 2 6.937c-.1 2.893 2.474 5.212 6.41 8.768l.075.067a1.5 1.5 0 0 0 2.017-.007l.082-.075c3.936-3.549 6.507-5.868 6.41-8.761a4.072 4.072 0 0 0-1.755-3.191zM9.571 14.594l-.075.075-.075-.075C5.852 11.38 3.5 9.255 3.5 7.1a2.555 2.555 0 0 1 2.624-2.61A2.931 2.931 0 0 1 8.8 6.251h1.4a2.913 2.913 0 0 1 2.669-1.76A2.555 2.555 0 0 1 15.494 7.1c0 2.155-2.355 4.28-5.923 7.494z",
    transform: "translate(-1.996 -2.193)",
    style: {
      fill: "#2d3e5c"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLike);
export default __webpack_public_path__ + "static/media/Like.eff3796ecb9b2cc1760fd62b2be1be52.svg";
export { ForwardRef as ReactComponent };